"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var library_airtable_cms_text_1 = require("@talus-analytics/library.airtable.cms-text");

var RenderCMSRichText_1 = __importDefault(require("./RenderCMSRichText"));

var CMSRichText = function CMSRichText(_ref) {
  var data = _ref.data,
      name = _ref.name,
      _ref$noEmitError = _ref.noEmitError,
      noEmitError = _ref$noEmitError === void 0 ? false : _ref$noEmitError;
  var markdown = (0, library_airtable_cms_text_1.getCMSText)(data, name, noEmitError);
  if (!markdown) return react_1.default.createElement(react_1.default.Fragment, null);
  return react_1.default.createElement(RenderCMSRichText_1.default, {
    markdown: markdown
  });
};

exports.default = CMSRichText;